import { render, staticRenderFns } from "./AccountingFirmUserChargeControl.vue?vue&type=template&id=f888c638&scoped=true"
import script from "./AccountingFirmUserChargeControl.vue?vue&type=script&lang=js"
export * from "./AccountingFirmUserChargeControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f888c638",
  null
  
)

export default component.exports